<template>
    <div class="account">
        <div class="top_header_fixed">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/flowSourceConfigList' }">流向配置</el-breadcrumb-item>
                <el-breadcrumb-item>流向配置{{ type == 'update' ? '编辑' : '新增' }}</el-breadcrumb-item>
            </el-breadcrumb>
            <div class="title_btn">
                <div>
                    <el-button size="small" plain @click="submit()" :loading="btnLoading">保存</el-button>
                    <el-button size="small" plain @click="cancel">取消</el-button>
                </div>
            </div>
        </div>

        <div class="main_list">
            <el-collapse v-model="activeNames">
                <el-collapse-item disabled title="基本信息" name="1">
                    <el-form :model="formData" :rules="rules" ref="submitForm" label-position="right" class="details_temp2023">
                        <el-form-item label="账户：" :rules="rules['account_rid']" prop="account_rid">
                            <vSearchSelect
                                model_key="account_rid"
                                model_name="请输入账户搜索"
                                request_uri="searchAccounts"
                                :is_disabled="type == 'update'"
                                default_option_key="account_option"
                                :default_option="formData['account_option']"
                                @onDropChange="onDropChange"
                                ref="account_ref"
                            ></vSearchSelect>
                        </el-form-item>
                        <el-form-item label="备注：">
                            <el-input v-model="formData.remark" size="mini" placeholder="请输入备注" clearable></el-input>
                        </el-form-item>
                    </el-form>
                </el-collapse-item>
                <el-collapse-item disabled title="流向" name="2" style="margin-top: -20px">
                    <el-form :model="formDataF" ref="submitFormF" label-position="right" class="details_temp2023">
                        <template v-for="(item, index) in data.F">
                            <el-form-item :key="index" :label="item['label'] + '：'" :required="item['required']">
                                <el-input v-model="formDataF[item['prop']]" size="mini" placeholder="请输入关联字段" clearable></el-input>
                            </el-form-item>
                        </template>
                    </el-form>
                </el-collapse-item>
                <el-collapse-item disabled title="采购" name="3" style="margin-top: -20px">
                    <el-form :model="formDataP" ref="submitFormP" label-position="right" class="details_temp2023">
                        <template v-for="(item, index) in data.P">
                            <el-form-item :key="index" :label="item['label'] + '：'" :required="item['required']">
                                <el-input v-model="formDataP[item['prop']]" size="mini" placeholder="请输入关联字段" clearable></el-input>
                            </el-form-item>
                        </template>
                    </el-form>
                </el-collapse-item>
                <el-collapse-item disabled title="库存" name="4" style="margin-top: -20px">
                    <el-form :model="formDataS" ref="submitFormS" label-position="right" class="details_temp2023">
                        <template v-for="(item, index) in data.S">
                            <el-form-item
                                v-if="!in_array(item['prop'], [''])"
                                :key="index"
                                :label="item['label'] + '：'"
                                :required="item['required']"
                            >
                                <el-input v-model="formDataS[item['prop']]" size="mini" placeholder="请输入关联字段" clearable></el-input>
                            </el-form-item>
                            <el-form-item v-else :key="index"></el-form-item>
                        </template>
                    </el-form>
                </el-collapse-item>
            </el-collapse>
        </div>
    </div>
</template>
<script>
import vSearchSelect from '@/components/common/dropdown/search.vue';
import { in_array } from '../../../../js/common';

export default {
    name: 'flowSourceConfigEdit',
    components: {
        vSearchSelect
    },
    data() {
        return {
            type: '', // insert or update or copy
            activeNames: ['1', '2', '3', '4'],
            btnLoading: false,
            formData: {}, // 表单信息
            formDataF: {}, // 流向信息
            formDataP: {}, // 采购信息
            formDataS: {}, // 库存信息
            data: {}, // 详情数据
            fieldTypeMap: {},
            queryParams: {}, // 搜索参数（详情）
            rules: {} // 表单验证信息
        };
    },
    created() {
        this.type = this.$route.query.type;
        this.initQueryParams();
        this.initFormRule();
        this.getData();
    },
    methods: {
        in_array,
        onDropChange(key, value) {
            this.formData[key] = value;
        },
        initFormRule() {
            this.rules = {
                account_rid: [{ required: true, message: '账户必填', trigger: 'blur' }]
            };
        },
        initQueryParams() {
            this.queryParams.account_rid = this.$route.query.account_rid;
        },
        //获取详情
        getData() {
            this.$api
                .flowSourceConfigDetail(this.queryParams)
                .then((res) => {
                    this.data = res.data;
                    this.initFormData();
                })
                .catch((error) => {});
        },
        initFormData() {
            if (this.type == 'copy') {
                this.formData = {
                    account_rid: '',
                    account_option: { rid: '', name: '' },
                    remark: this.data.remark || ''
                };
            } else {
                this.formData = {
                    account_rid: this.data.account_rid || '',
                    account_option: { rid: this.data.account_rid || '', name: this.data.account_name || '' },
                    remark: this.data.remark || ''
                };
            }

            this.formDataF = this.processFormDataX(this.data.F);
            this.formDataP = this.processFormDataX(this.data.P);
            this.formDataS = this.processFormDataX(this.data.S);
        },
        processFormDataX(data) {
            let res = {};
            Object.keys(data).forEach((key) => {
                res[key] = data[key]['source_label'];
            });
            return res;
        },
        //取消
        cancel() {
            if (window.history.length <= 1) {
                this.$router.push({ path: '/flowSourceConfigList' });
            } else {
                this.$router.go(-1);
            }
        },
        //提交新增/编辑修改
        submit() {
            let formNames = ['submitForm', 'submitFormF', 'submitFormP', 'submitFormS'];
            let flag = 0;
            formNames.forEach((item) => {
                this.$refs[item].validate((valid) => {
                    if (valid) {
                        flag++;
                    }
                });
            });
            if (flag == formNames.length) {
                this.doSubmit();
                return true;
            } else {
                return false;
            }
        },
        doSubmit() {
            this.btnLoading = true;
            let uri = '';
            if (this.type == 'update') {
                uri = 'flowSourceConfigUpdate';
            } else {
                uri = 'flowSourceConfigInsert';
            }

            this.$api[uri]({
                account_rid: this.formData.account_rid,
                remark: this.formData.remark,
                data: {
                    F: this.formDataF,
                    P: this.formDataP,
                    S: this.formDataS
                }
            })
                .then((res) => {
                    this.btnLoading = false;
                    this.$message({
                        message: '保存成功！',
                        type: 'success'
                    });
                    this.cancel();
                })
                .catch((error) => {
                    this.btnLoading = false;
                });
        }
    }
};
</script>
<style lang="scss" scoped="scoped">
.red:after {
    content: '*';
    color: #f56c6c;
    margin-right: 4px;
}
</style>